import { useSearchParams, useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RotateCcw } from 'lucide-react';

export const BookingCancel = ({ lang, t }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center" data-testid="booking-cancel">
        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        <h1 className="text-3xl lg:text-4xl font-light text-white mb-4 tracking-tighter" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          {t('cancel.title')}
        </h1>
        <p className="text-white/70 mb-8">
          {t('cancel.message')}
        </p>

        <div className="space-y-4">
          <button
            onClick={() => {
              navigate('/');
              // Scroll to booking section
              setTimeout(() => {
                const element = document.getElementById('booking');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="retry-booking-btn"
          >
            <RotateCcw size={18} />
            {t('cancel.retry')}
          </button>

          <button
            onClick={() => navigate('/')}
            className="btn-secondary w-full flex items-center justify-center gap-2"
            data-testid="back-home-btn"
          >
            <ArrowLeft size={18} />
            {t('success.backHome')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingCancel;
